// extracted by mini-css-extract-plugin
export default {"contentContainer":"MainContentLayout_contentContainer__tXHPQ","stickyPanel":"MainContentLayout_stickyPanel__gYd8G"};